import {useTranslation} from 'react-i18next';

import {MatchStatus} from '../../../../types/MatchStatus/MatchStatus';
import {humanizeSnakeCase} from '../../../../utils/humanizeSnakeCase';

type Props = {
  status?: string;
};

const statusTranslationKeyByMatchStatus: Partial<
  Record<MatchStatus, 'accepted' | 'contacted' | 'interview' | 'hired' | 'rejected' | 'onHold'>
> = {
  [MatchStatus.Accepted]: 'accepted',
  [MatchStatus.Contacted]: 'contacted',
  [MatchStatus.Interview]: 'interview',
  [MatchStatus.Hired]: 'hired',
  [MatchStatus.Rejected]: 'rejected',
  [MatchStatus.OnHold]: 'onHold',
};

export const MatchStatusLabel = ({status}: Props) => {
  const {t} = useTranslation('translation', {keyPrefix: 'companyApplicants.applicantsCard.menuItems'});

  if (!status) {
    return <>—</>;
  }

  const translationKey = statusTranslationKeyByMatchStatus[status.toLowerCase() as MatchStatus];
  if (translationKey) {
    return <>{String(t(translationKey))}</>;
  }

  return <>{humanizeSnakeCase(status)}</>;
};
